import { FormContextValues, NumberPatternType } from '@dreryk/react-common';

import { isNull } from '~libs.typescript';

import { translationKeys } from '../../../translations';

import { GroupSessionsMaxParticipantsFieldFormBeanPart } from './GroupSessionsMaxParticipantsField.types';
import { StyledNumberInput } from './GroupSessionsMaxParticipantsField.styled';

const MAX_PARTICIPANTS_MAX_VALUE = 99;
const MAX_PARTICIPANTS_MIN_VALUE = 2;
const MAX_PARTICIPANTS_STEP_VALUE = 1;
const MAX_PARTICIPANTS_DEFAULT_VALUE = 2;

type GroupSessionsMaxParticipantsFieldProps = Pick<
   FormContextValues<GroupSessionsMaxParticipantsFieldFormBeanPart>,
   'register' | 'getValue' | 'setValue'
>;

export const GroupSessionsMaxParticipantsField = (props: GroupSessionsMaxParticipantsFieldProps): JSX.Element => {
   return (
      <StyledNumberInput
         testId={'maxParticipants'}
         controller={props.register('maxParticipants', {
            validate: (value) => {
               const maxParticipants = value as number | null;
               const minParticipants = props.getValue('minParticipants');

               if (isNull(maxParticipants)) {
                  props.setValue(
                     'maxParticipants',
                     Math.max(minParticipants ?? MAX_PARTICIPANTS_MIN_VALUE, MAX_PARTICIPANTS_DEFAULT_VALUE)
                  );
                  return true;
               }

               if (maxParticipants > MAX_PARTICIPANTS_MAX_VALUE) {
                  props.setValue('maxParticipants', MAX_PARTICIPANTS_MAX_VALUE);
                  return true;
               }

               if (minParticipants && minParticipants > maxParticipants) {
                  props.setValue('maxParticipants', minParticipants);
                  return true;
               }

               return true;
            },
            required: true,
         })}
         label={translationKeys.maxParticipants}
         defaultValue={MAX_PARTICIPANTS_DEFAULT_VALUE}
         stepValue={MAX_PARTICIPANTS_STEP_VALUE}
         pattern={NumberPatternType.POSITIVE_INTEGER}
      />
   );
};
